module.exports = __webpack_public_path__ + "static/media/siddharth-mysuru-trip-30.16b289e2.png";